import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "drag",
  "use": "drag-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"drag\">\r\n<line x1=\"7\" y1=\"9.5\" x2=\"17\" y2=\"9.5\" stroke=\"currentColor\" />\r\n<line x1=\"7\" y1=\"12.5\" x2=\"17\" y2=\"12.5\" stroke=\"currentColor\" />\r\n<line x1=\"7\" y1=\"15.5\" x2=\"17\" y2=\"15.5\" stroke=\"currentColor\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol